import React, { useRef, useState } from "react";
import { Overlay, Popover, Col, Row, Form } from "react-bootstrap";
import filter from "../../assets/images/filt.svg";
import close from "../../assets/images/close.svg";
import { qutationDateFormat } from "../../actions";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import moment from "moment";
import { toast } from "react-toastify";

function ProductFilter(props) {
    const [show, setShow] = useState(false);
    const [cur, setCur] = useState("");
    const [eff, setEff] = useState("");
    const [groupId, setGroupId] = useState("");
    const [subGroupId, setSubGroupId] = useState("");

    const { onSubmit, reset, groups = [] } = props;

    // the group dropdown already carries its active sub groups, so choosing a
    // group narrows the sub group list without another round trip
    const UNGROUPED = "ungrouped";
    const isUngrouped = groupId === UNGROUPED;
    const selectedGroup = groups.find(g => String(g.productGroupId) === String(groupId));
    const subGroups = selectedGroup?.subGroups || [];

    const groupHandler = (e) => {
        setGroupId(e.target.value);
        setSubGroupId("");   // the old sub group belongs to the old group
    };

    const [target, setTarget] = useState(null);
    const ref = useRef(null);

    const handleClick = (event) => {
        setShow(!show);
        setTarget(event.target);
    };

    const handleClose = () => {
        setShow(false);
        setTarget(null);
    };


    const disabledDate = (current) => current && current > moment().endOf("day");
    const checkDisabledDate = (current) => (current && current > moment().endOf("day")) || moment(eff).startOf("day") > current;

    const effHandler = (val) => {
        let item = val === null ? "" : qutationDateFormat(val._d);
        setCur(item);
    }
    const currentHandler = (val) => {
        let item = val === null ? "" : qutationDateFormat(val._d);
        setEff(item);
    }


    const submitHandler = (e) => {
        e.preventDefault();
        let data = {
            "fromDate": eff,
            "toDate": cur,
            "productGroupId": isUngrouped ? "" : groupId,
            "productSubGroupId": isUngrouped ? "" : subGroupId,
            "ungrouped": isUngrouped ? true : ""
        }
        onSubmit(data);
        setTarget(null);
        setShow(false);
    }

    const resetHandler = () => {
        reset();
        setCur("");
        setEff("");
        setGroupId("");
        setSubGroupId("");
        setTarget(null);
        setShow(false);
    }


    return (
        <div ref={ref} className="filter-background">
            <button onClick={handleClick} className="product-filter-button">
                <img src={filter} alt="..." width="18px" style={{ paddingRight: "5px" }} /> Filter
            </button>
            <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
            >
                <Popover id="popover-contained">
                    <Popover.Header>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <p style={{ margin: 0 }}>Filter Products</p>
                            <img
                                src={close}
                                alt="Close"
                                width="16px"
                                style={{ cursor: "pointer", marginLeft: 'auto' }}
                                onClick={handleClose}
                            />
                        </div>
                    </Popover.Header>
                    <Popover.Body>
                        <div className="filter-page">
                            <Form onSubmit={submitHandler}>
                                <Form.Group controlId="filterProductGroup">
                                    <label className="pf-filter-label">Product Group</label>
                                    <Form.Control as="select" value={groupId} onChange={groupHandler}>
                                        <option value="">All groups</option>
                                        {groups.map(group => (
                                            <option value={group.productGroupId} key={group.productGroupId}>
                                                {group.groupName}
                                            </option>
                                        ))}
                                        <option value={UNGROUPED}>Not in any group</option>
                                    </Form.Control>
                                </Form.Group><br></br>
                                <Form.Group controlId="filterProductSubGroup">
                                    <label className="pf-filter-label">Sub Group</label>
                                    <Form.Control
                                        as="select"
                                        value={subGroupId}
                                        disabled={!groupId || isUngrouped}
                                        onChange={(e) => setSubGroupId(e.target.value)}
                                    >
                                        <option value="">
                                            {isUngrouped
                                                ? "Not applicable"
                                                : groupId ? "All sub groups" : "Pick a group first"}
                                        </option>
                                        {subGroups.map(sg => (
                                            <option value={sg.productSubGroupId} key={sg.productSubGroupId}>
                                                {sg.subGroupName}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group><br></br>
                                <Form.Group controlId="formBasicDate">
                                    <DatePicker
                                        format="DD-MM-YYYY"
                                        placeholder={eff !== "" ? eff : "From Date"}
                                        className="form-control"
                                        onChange={currentHandler}
                                        disabledDate={disabledDate}
                                    />
                                </Form.Group><br></br>
                                <Form.Group controlId="formBasicDate">
                                    <DatePicker
                                        format="DD-MM-YYYY"
                                        placeholder={cur !== "" ? cur : "To Date"}
                                        className="form-control"
                                        onChange={effHandler}
                                        disabledDate={checkDisabledDate}
                                    />
                                </Form.Group>

                                <div>
                                    <Row>
                                        <Col md={6}>
                                            <button className="modal-price reset" type="button" onClick={resetHandler}>
                                                Reset</button>
                                        </Col>
                                        <Col md={6}>
                                            <button type="submit" className="modal-btn modal-apply">
                                                Apply
                                            </button>
                                        </Col>
                                    </Row>

                                </div>
                            </Form>
                        </div>
                    </Popover.Body>
                </Popover>
            </Overlay>
        </div>
    );
}


export default ProductFilter;


